/**
 * القسم 5 — «الإطار الاقتصادي والمالي ونموذج الإيرادات للمبادرة الإعلامية» (ملف PDF العربي).
 * النطاقات الرقمية مكتوبة بشرطة عادية (-) حتى تُعرض بالترتيب الصحيح داخل النص العربي.
 */
export const financialAr = {
  id: 'financial',
  previewCount: 4,
  navLabel: 'النموذج المالي',
  eyebrow: 'الإطار الاقتصادي والمالي',
  title: 'الإطار الاقتصادي والمالي ونموذج الإيرادات للمبادرة الإعلامية',
  subtitle:
    'مشروع إعلامي اقتصادي قابل للتنفيذ والتوسع وتحقيق عوائد تجارية واضحة، بإيرادات إعلامية مستهدفة تقارب 6.4 ملايين دولار سنويًا.',
  blocks: [
    {
      icon: 'description',
      title: 'الهدف من الإطار',
      wide: true,
      paragraphs: [
        'يحدد هذا الإطار النموذج الاقتصادي والمالي للمبادرة الإعلامية الاقتصادية العالمية، ومصادر الإيرادات، وطبيعة العلاقة المالية بين نادي حلول والوكالات والشركاء الإعلاميين، بما يتيح بناء مشروع إعلامي اقتصادي قابل للتنفيذ والتوسع وتحقيق عوائد تجارية واضحة.',
        'وتقوم المبادرة على بناء برنامج إعلامي اقتصادي متكامل يمكن تشغيله في دولة واحدة ثم تكرار النموذج في أسواق ودول أخرى، بما يتيح زيادة القيمة الإعلامية والتجارية للمشروع مع التوسع الدولي.',
      ],
    },
    {
      icon: 'account_balance_wallet',
      title: 'النموذج الاقتصادي للمبادرة',
      paragraphs: ['يعتمد النموذج الاقتصادي للمبادرة على نوعين رئيسيين من النشاط والإيرادات:'],
      labeled: [
        {
          label: 'أولًا: الإيرادات الإعلامية والإعلانية',
          text: 'وهي الإيرادات الناتجة عن الرعاية والإعلانات والظهور الإعلامي والباقات والخدمات الإعلامية المختلفة المرتبطة بالبرنامج، وهي المجال الذي يتم من خلاله بناء العلاقة التجارية مع الوكالة والشركاء الإعلاميين.',
        },
        {
          label: 'ثانيًا: الفرص والصفقات الاقتصادية والاستثمارية',
          text: 'وهي الفرص والصفقات والشراكات التي تتم من خلال نادي حلول مع المستثمرين والشركات والجهات والمؤسسات المعنية، وفق اتفاقات خاصة ومستقلة بين الأطراف المعنية، ولا تدخل ضمن العلاقة المالية الإعلامية مع الوكالة.',
        },
      ],
    },
    {
      icon: 'movie',
      title: 'تكلفة البرنامج والإيرادات المستهدفة',
      paragraphs: [
        'يُبنى النموذج المالي على برنامج أسبوعي بإجمالي يقارب 50-52 حلقة سنويًا. وتختلف تكلفة الإنتاج من دولة إلى أخرى وفقًا لمستوى الإنتاج والقناة وطبيعة السوق وتكلفة العمالة والتجهيزات والتصوير والتنفيذ.',
        'ولأغراض الدراسة الأولية، يمكن اعتماد التكلفة التقديرية التالية:',
      ],
      stats: [
        { value: '50–52', label: 'حلقة سنويًا' },
        { value: '$30K–$60K', label: 'تكلفة تقديرية للحلقة' },
        { value: '$1.5M–$3.0M', label: 'سنويًا لموسم من 50 حلقة' },
      ],
      closing: [
        'ويُستخدم هذا النطاق باعتباره تقديرًا استرشاديًا قابلًا للتعديل، وليس سعرًا ثابتًا أو ملزمًا، على أن يتم تحديد التكلفة النهائية من خلال الوكالة والقناة وفق نموذج الإنتاج الفعلي.',
        'ويهدف النموذج التجاري إلى أن تتجاوز الإيرادات الإعلامية والإعلانية تكلفة الإنتاج بصورة تحقق هامش ربح مناسبًا لجميع الأطراف.',
      ],
    },
    {
      type: 'table',
      icon: 'table_chart',
      title: 'التصور التقديري للإيرادات الإعلامية السنوية',
      wide: true,
      paragraphs: [
        'يمتلك البرنامج عددًا كبيرًا من الوحدات والمساحات الإعلامية القابلة للرعاية والإعلان والبيع التجاري، ويمكن تسعيرها منفردة أو تجميعها في باقات. والتصور التالي نموذج تقديري أولي قابل للتعديل:',
      ],
      headers: ['مصدر الإيراد', 'العدد أو الفرضية', 'القيمة التقديرية', 'الإيراد السنوي التقديري'],
      rows: [
        ['الراعي الرئيسي للبرنامج', '1', '400,000 دولار', '400,000'],
        ['الرعاة الرئيسيون للقطاعات', '10', '150,000 دولار', '1,500,000'],
        ['الرعاة المتخصصون', '10', '100,000 دولار', '1,000,000'],
        ['رعاة الفقرات', '15', '50,000 دولار', '750,000'],
        ['إعلانات داخل الحلقة', 'وفق الباقات والعدد', '—', '750,000'],
        ['إعلانات الفواصل', 'وفق أسعار السوق والعدد', '—', '750,000'],
        ['ظهور شعارات الشركات والمساحات المستمرة', 'وفق الباقات', '—', '750,000'],
        ['محتوى إعلامي وإعلاني خاص للشركات', 'وفق الباقات', '—', '500,000'],
      ],
      footer: { label: 'الإجمالي المستهدف التقديري', value: '6,400,000 دولار سنويًا' },
      notes: [
        'وتتضمن الرعاية القطاعية قطاعات ترتبط بطبيعة نادي حلول والأسواق التي يعمل فيها، ومن بينها: التطوير والاستثمار العقاري، البنوك والتمويل، الاستثمار، الاتصالات، التكنولوجيا، الإنشاءات، مواد البناء، التصميم والهندسة، الأثاث والتجهيزات، الخدمات القانونية، التقييم والاستشارات، إدارة العقارات، السياحة والضيافة، النقل والخدمات اللوجستية، التأمين، الطاقة، والخدمات المؤسسية والمالية وغيرها.',
        'ولا يشترط استقطاب جميع هذه الفئات في كل دولة، وإنما يتم تحديد القطاعات والرعاة وفق طبيعة كل سوق والبرنامج والقناة.',
      ],
    },
    {
      icon: 'redeem',
      title: 'ما يحصل عليه الراعي أو المعلن',
      paragraphs: [
        'تتحدد قيمة كل رعاية أو باقة وفق حجم الظهور والخدمات الإعلامية التي يحصل عليها العميل، ويمكن أن تشمل بصورة تقديرية:',
      ],
      bullets: [
        'ظهور اسم وشعار الشركة داخل البرنامج.',
        'الظهور في بداية الفقرة أو نهايتها.',
        'الظهور داخل الحلقة وفي المواد الترويجية.',
        'الإعلانات أثناء الحلقة أو بين الفواصل.',
        'رعاية فقرة أو ملف اقتصادي محدد.',
        'تقديم الشركة أو المسؤول التنفيذي بصورة إعلامية متكاملة.',
        'عرض المعلومات الأساسية عن الشركة ونشاطها عند الظهور.',
        'الظهور في المواد الرقمية والإعلامية المصاحبة.',
        'تغطية أو محتوى إعلامي خاص بالشركة بحسب الباقة.',
        'أولوية أو مزايا إضافية عند الاشتراك في الباقات الدولية.',
      ],
      closing: [
        'وتحدد الوكالة والقناة القيمة النهائية لكل منتج أو باقة بحسب السوق وقوة البرنامج وحجم الجمهور وعدد مرات الظهور ومدته وطبيعة الخدمات المقدمة.',
        'الأرقام الواردة في هذا الإطار تقديرية واسترشادية وليست أسعارًا ملزمة، ويمكن لكل وكالة تحديد الأسعار النهائية بما يتناسب مع السوق المحلي والقناة وحجم الجمهور والقيمة التجارية للبرنامج.',
      ],
    },
    {
      icon: 'public',
      title: 'الباقات الدولية',
      paragraphs: [
        'تمثل الباقات الدولية أحد أهم عناصر التوسع التجاري للمبادرة، حيث يمكن للشركات والمؤسسات شراء حضور إعلامي متكامل في أكثر من دولة وبرنامج ضمن شبكة حلول.',
        'فعلى سبيل المثال، يمكن تقديم باقة دولية تشمل 5 برامج في 5 أسواق:',
      ],
      stats: [
        { value: '$1,000,000', label: 'قيمة استرشادية سنويًا' },
        { value: '5', label: 'برامج في 5 أسواق' },
        { value: '$200,000', label: 'المتوسط لكل سوق / برنامج' },
      ],
      listLabel: 'وتتضمن، بحسب تصميم الباقة:',
      bullets: [
        'الظهور في البرامج الخمسة في الأسواق المشاركة.',
        'ظهور إعلاني داخل البرامج وعبر الفواصل بحسب العدد المتفق عليه.',
        'ظهور شعار الشركة والهوية التجارية في البرامج والمواد المصاحبة.',
        'رعاية أو ظهور في فقرات أو ملفات اقتصادية مختارة.',
        'تقديم الشركة أو مسؤوليها في الظهور الإعلامي المناسب.',
        'محتوى إعلامي وإعلاني خاص بالشركة عبر الأسواق المشاركة.',
        'الاستفادة من المنصات الرقمية والإعلامية المصاحبة.',
        'تغطية إعلامية دولية مرتبطة بنشاط الشركة وحضورها في الأسواق المستهدفة.',
      ],
      closing:
        'وعند توزيع قيمة الباقة على خمسة أسواق يكون المتوسط الحسابي 200,000 دولار لكل سوق/برنامج، ويتم تحديد التفاصيل النهائية للتوزيع والتسوية بين الأسواق والوكالات المشاركة وفق الاتفاق الدولي المنظم للشبكة.',
    },
    {
      icon: 'handshake',
      title: 'العلاقة المالية بين حلول والوكالة',
      paragraphs: [
        'يتم تحديد العلاقة المالية بين نادي حلول والوكالة وفق نموذج التعاون المعتمد لكل سوق، ويكون النموذج المرجعي المقترح للإيرادات الإعلامية المشتركة:',
      ],
      stats: [
        { value: '50%', label: 'لحلول' },
        { value: '50%', label: 'للوكالة' },
      ],
      closing:
        'ويتم تحديد النسبة النهائية تعاقديًا وفق طبيعة الشراكة والدور الذي تقوم به كل جهة.',
    },
    {
      icon: 'flag',
      title: 'خدمة الدولة',
      paragraphs: [
        'تقوم المبادرة، من خلال نادي حلول، بدور اقتصادي وإعلامي يخدم الدولة التي يتم تنفيذ البرنامج فيها، من خلال تقديم مساحة إعلامية للتعريف باقتصاد الدولة وفرصها الاستثمارية ومشروعاتها وأسواقها واحتياجاتها، وربطها بالمستثمرين والشركات والمؤسسات والأسواق الدولية.',
        'ويُقدَّم هذا الدور للدولة دون مقابل مالي من الدولة لنادي حلول، باعتباره جزءًا من الدور الاقتصادي والوطني للمبادرة.',
        'وفي المقابل، تستفيد المبادرة من التعاون المؤسسي للدولة وما توفره من تسهيلات وتنسيق رسمي ومعلومات ومشاركة المسؤولين والجهات المعنية، إلى جانب التسهيلات اللوجستية اللازمة لتنفيذ البرنامج.',
      ],
      closing:
        'أما أي فرص أو أعمال أو استثمارات تنتج بين نادي حلول والمستثمرين أو الشركات أو الجهات الأخرى، فتتم وفق اتفاقات مستقلة بين الأطراف المعنية.',
    },
    {
      type: 'table',
      icon: 'monitoring',
      title: 'المؤشرات المالية الأولية',
      headers: ['المؤشر', 'التصور الأولي'],
      rows: [
        ['عدد الحلقات', '50-52 حلقة سنويًا'],
        ['تكلفة الحلقة التقديرية', '30,000-60,000 دولار'],
        ['تكلفة الموسم التقديرية', '1.5-3 ملايين دولار'],
        ['الإيرادات الإعلامية المستهدفة', 'نحو 6.4 ملايين دولار سنويًا في النموذج التقديري'],
        ['الباقة الدولية الاسترشادية', '1,000,000 دولار لخمسة أسواق'],
        ['نموذج توزيع الإيرادات الإعلامية', '50% لحلول / 50% للوكالة'],
      ],
      notes: [
        'وتظل هذه الأرقام تقديرية قابلة للتعديل بحسب الدولة والسوق والقناة ومستوى الإنتاج والقيمة الإعلامية والتجارية الفعلية للبرنامج.',
      ],
    },
    {
      icon: 'insights',
      title: 'الخلاصة المالية',
      wide: true,
      highlight: true,
      paragraphs: ['يقوم النموذج المالي للمبادرة على معادلة واضحة:'],
      flow: [
        'الإنتاج المحلي يتم تمويله من السوق الإعلامي المحلي',
        'الرعاية والإعلانات والخدمات الإعلامية تحقق الإيرادات',
        'تغطي الإيرادات تكلفة الإنتاج',
        'يتحقق الربح',
        'يتوسع النموذج إلى أسواق ودول أخرى',
        'ترتفع القيمة الإعلامية والتجارية للشبكة',
        'تنمو الإيرادات المحلية والدولية',
      ],
      closing:
        'وبذلك يصبح البرنامج مشروعًا إعلاميًا اقتصاديًا متكاملًا قابلًا للتكرار والتوسع، وليس مجرد برنامج يعتمد على مصدر إعلاني واحد.',
    },
  ],
};
